import React from 'react'

import ContactInformationForm from 'app/gears/profile/components/ContactInformationForm'
import validations from 'app/utils/validations'

const contactInformationFormValuesFromUser = (user) => ({
  id: user.id,
  email: user.email,
  primaryPhoneNumber: user.primaryPhoneNumber,
  primaryPhoneNumberExtension: user.primaryPhoneNumberExtension,
  primaryPhoneNumberType: user.primaryPhoneNumberType,
  secondaryPhoneNumber: user.secondaryPhoneNumber,
  secondaryPhoneNumberExtension: user.secondaryPhoneNumberExtension,
  secondaryPhoneNumberType: user.secondaryPhoneNumberType,
  userStation: user.userStation,
  jobTitle: user.jobTitle,
  vaEauthSecId: user.vaEauthSecId
})

const ContactInformationPage = ({ user, updateUser, stationList }) =>
  <ContactInformationForm
    form='userAdminContactInformationForm'
    validations={validations}
    initialValues={contactInformationFormValuesFromUser(user)}
    onSubmit={updateUser}
    stationList={stationList.stations} // TODO: confusing prop name here
    user={user}
    isSuccess={false} />

export default ContactInformationPage